import { useState, useCallback } from 'react';
import { IResearchFilterState, IResearchFilterItems } from '@/creditflowresearch/domain/vo/research/IFilterContextData';
import { INITIAL_FILTER_STATE, INITIAL_ITEMS } from '@/creditflowresearch/application/Research/constants';

interface IFilterState {
  isFetching: boolean,
  items: IResearchFilterItems,
  initialFilters: IResearchFilterState,
  appliedFilters: IResearchFilterState,
  filtersPayload: IResearchFilterState | null,
  dateFromMin: number | null,
  dateToMax: number | null,
}

interface IFilterStateActions {
  setIsFetching: (isFetching: boolean) => void,
  setItems: (items: IResearchFilterItems) => void,
  setInitialFilters: (filters: IResearchFilterState) => void,
  setAppliedFilters: (filters: IResearchFilterState) => void,
  setFiltersPayload: (payload: IResearchFilterState | null) => void,
  setMinMaxDatePeriod: (dateFrom: number, dateTo: number) => void,
  resetState: () => void,
}

export const useFilterState = (): IFilterState & IFilterStateActions => {
  const [isFetching, setIsFetching] = useState(false);
  const [items, setItems] = useState<IResearchFilterItems>(INITIAL_ITEMS);
  const [initialFilters, setInitialFilters] = useState<IResearchFilterState>(INITIAL_FILTER_STATE);
  const [appliedFilters, setAppliedFilters] = useState<IResearchFilterState>(INITIAL_FILTER_STATE);
  const [filtersPayload, setFiltersPayload] = useState<IResearchFilterState | null>(null);
  const [dateFromMin, setDateFromMin] = useState<number | null>(null);
  const [dateToMax, setDateToMax] = useState<number | null>(null);

  const setMinMaxDatePeriod = useCallback((dateFrom: number, dateTo: number) => {
    setDateFromMin(dateFrom);
    setDateToMax(dateTo);
  }, []);

  const resetState = useCallback(() => {
    setIsFetching(false);
    setItems(INITIAL_ITEMS);
    setInitialFilters(INITIAL_FILTER_STATE);
    setAppliedFilters(INITIAL_FILTER_STATE);
    setFiltersPayload(null);
    setDateFromMin(null);
    setDateToMax(null);
  }, []);

  return {
    isFetching,
    items,
    initialFilters,
    appliedFilters,
    filtersPayload,
    dateFromMin,
    dateToMax,
    setIsFetching,
    setItems,
    setInitialFilters,
    setAppliedFilters,
    setFiltersPayload,
    setMinMaxDatePeriod,
    resetState,
  };
};
